"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
const react_1 = require("react");
/**
 * Local storage hook
 */
function useLocalStorage(key, initialValue) {
    const readLocalStorageValue = (0, react_1.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            console.error(error);
            return initialValue;
        }
    }, [key, initialValue]);
    const [storedValue, setStoredValue] = (0, react_1.useState)(readLocalStorageValue());
    const setValue = (0, react_1.useCallback)((value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
                window.dispatchEvent(new Event('local-storage'));
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [storedValue, setStoredValue]);
    const localStorageEventHandler = (0, react_1.useCallback)(() => {
        setStoredValue(readLocalStorageValue());
    }, [setStoredValue, readLocalStorageValue]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('local-storage', localStorageEventHandler);
        return () => window.removeEventListener('local-storage', localStorageEventHandler);
    }, [localStorageEventHandler]);
    return [storedValue, setValue];
}
exports.useLocalStorage = useLocalStorage;
